import { Route } from "react-router-dom";
import { ProtectedRoute } from "@/routes/ProtectedRoute.jsx";
import TemplateAdmin from "@/layout/TemplateAdmin.jsx";
import UserProfile from "@/pages/shared/UserProfile.jsx";
import Dashboard from "@/pages/shared/Dashboard.jsx";
import { ROLES } from "@/config/roles.js";
import i18n from "@/i18n.js";

const SharedRoutes = (
  <Route
    element={
      <ProtectedRoute
        allowedRoles={[ROLES.USER, ROLES.ADMIN, ROLES.SUPER_ADMIN]}
      />
    }
  >
    <Route
      path="/my_profile"
      element={
        <TemplateAdmin
          title={i18n.t("page.myProfile")}
          content={<UserProfile />}
        />
      }
    />
    <Route
      path="/dashboard"
      element={
        <TemplateAdmin
          title={i18n.t("page.home")}
          breadcrumb={false}
          content={<Dashboard />}
        />
      }
    />
  </Route>
);

export default SharedRoutes;
